import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/lvyun-theme.css'
import './styles/admin-select.css'
import './styles/tablet-mode.css'
import './styles/inventory-compact.css'
import api from './api/client'
import { uiMode, applyTabletModeClass } from './utils/uiMode'
import { initAuthActivityTracking } from './utils/auth'
import AdminPagination from './components/AdminPagination.vue'
import {
  formatDateTime,
  formatDate,
  formatTime,
  formatBeijingDateTime
} from './utils/dateTimeUtils'

Vue.use(ElementUI)
Vue.component('AdminPagination', AdminPagination)

Vue.prototype.$formatDateTime = formatDateTime
Vue.prototype.$formatDate = formatDate
Vue.prototype.$formatTime = formatTime
Vue.prototype.$formatBeijingDateTime = formatBeijingDateTime

// 接口基址见 api/client.js（默认当前站点 /api；可设 VUE_APP_API_BASE 指向远程或本机 Node）
Vue.prototype.$api = api
Vue.prototype.$uiMode = uiMode

Vue.config.productionTip = false
initAuthActivityTracking()
applyTabletModeClass()

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')